import { grid, maxWidthContainer, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const linksBanner = css`
  ${grid}
  ${maxWidthContainer}
  grid-row-gap: 0;
`;

export const bottomOffsetImageMarginLinksBanner = css`
  padding-top: ${spacing.xxl}px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding-top: ${spacing.xl}px;
    `,
  )};
`;

export const imageWrapper = css`
  grid-column: span 12;
  margin-bottom: ${spacing.sm}px;

  ${mediaQuery(
    { min: minBreakpoints.XS },
    css`
      grid-column: 1 / span 6;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.S },
    css`
      grid-column: 1 / span 4;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: 1 / span 3;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 2 / span 3;
    `,
  )};
`;

export const subHeading = css`
  margin: auto 0;
  padding-bottom: ${spacing.lg}px;
  font-weight: normal;
  ${theme.responsiveText.BODY.SM}

  ${mediaQuery(
    { min: minBreakpoints.XXS },
    css`
      grid-column: span 12;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XS },
    css`
      grid-column: span 6;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.S },
    css`
      grid-column: span 8;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 9;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: none;
    `,
  )};
`;

export const content = css`
  margin: -${spacing.sm}px 0 ${spacing.base}px;
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: 1 / span 12;
      margin: 0;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 9;
      margin: ${spacing.xxl}px 0;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 6 / span 6;
    `,
  )};
`;
